import { Button, Modal } from 'react-bootstrap';
import { TipoFiltroRelatorios } from '../enum/tipo-filtro-relatorios.enum';

interface ModalFiltrosRelatoriosProps {
  show: boolean;
  // defensores: Defensor[];
  // defensorias: Defensoria[];
  // nucleos: Nucleo[];
  tipoFiltro: TipoFiltroRelatorios;
  handleHide: () => void;
  handleSetParametros: (params: string) => void;
}

export default function FiltrosCheckbox({
  show,
  tipoFiltro,
  handleHide,
  handleSetParametros,
}: ModalFiltrosRelatoriosProps) {
  function getTituloNome() {
    switch (tipoFiltro) {
      case TipoFiltroRelatorios.tipoAtendimento:
        return <>Tipo Atendimento</>;
      case TipoFiltroRelatorios.areaAtuacao:
        return <>Áreas de Atuação</>;
      case TipoFiltroRelatorios.servidores:
        return <>Servidores</>;
      case TipoFiltroRelatorios.defensorias:
        return <>Defensorias</>;
      case TipoFiltroRelatorios.defensores:
        return <>Defensores</>;
      case TipoFiltroRelatorios.comarcas:
        return <>Comarcas</>;
      case TipoFiltroRelatorios.diretorias:
        return <>Diretoria</>;
      case TipoFiltroRelatorios.qualificacoes:
        return <>Qualificações</>;
      default:
        return <></>;
    }
  }

  function onSubmit() {
    handleSetParametros('');
    handleHide();
  }

  return (
    <Modal show={show} onHide={handleHide} size="xl">
      <Modal.Header closeButton>
        <Modal.Title>
          Filtros para Relatório de Movimentações - {getTituloNome()}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h5>
          {/* <InputGridGenerico
						handleChange={() => { }}
						inputs={ }
						key={0} /> */}
        </h5>
      </Modal.Body>
      <Modal.Footer>
        <Button type="submit" variant="success" onClick={() => onSubmit()}>
          Aplicar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}